




















import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { ITag } from "@/models/tags";
import { ITagsProvider, ITagsProviderMethods } from "@/models/providers/tags";
import { TranslateResult } from "vue-i18n";

@Component({
  components: {
    "tags-cloud-view": () =>
      import("@/components/app/global/tags/tagsCloudView.vue")
  }
})
export default class TagsView extends Vue {
  @Inject({ from: "tagsProvider" })
  public tagsProvider!: () => ITagsProvider;

  @Inject({ from: "tagsMethods" })
  public $tagsMethods!: ITagsProviderMethods;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: () => [] })
  public activeIds!: ITag["id"][];

  @Prop({ default: true })
  public closableTags!: boolean;

  @Prop({ default: true })
  public canSelect!: boolean;

  @Prop({ default: false })
  public isAlignedCenter!: boolean;

  @Prop({ default: undefined })
  public addTagLabel?: string | TranslateResult;

  // Computed

  public get $tagsData() {
    return this.tagsProvider();
  }

  public get selectedTags() {
    return this.$_.orderBy(
      this.$_.filter(this.$tagsData.availableTags, tag =>
        this.activeIds.includes(tag.id)
      ),
      ["name"]
    );
  }

  public openSelectTagsModal() {
    this.$tagsMethods
      .openSelectTagsModal({ activeTags: this.selectedTags })
      .then((tags: ITag[]) => {
        this.$emit("tags-select-many", tags);
      });
  }

  public onCloseTag(tag) {
    this.$emit("tag-close", tag);
  }
}
